import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.css";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import * as constantMessages from "../../constants/constatntMessages";
import { setSuccess } from "../../redux/actions/minuteActions/MinuteAction";
import parse from "html-react-parser";
import { Accordion, OverlayTrigger, Popover } from "react-bootstrap";
import {
  checkEmptyString,
  cleanInput,
  getStringLengthAfterHTMLParse,
} from "../../helpers/commonHelpers";
import ReactQuill from "../../../node_modules/react-quill/lib/index";
import LoaderButton from "../Common/LoaderButton";
import { setInValidUser } from "../../redux/actions/authActions/authAction";
import { getSingleMeetingDetailsForUpdate } from "../../redux/actions/meetingActions/MeetingAction";
import { handleApiError } from "../../helpers/errorResponseHelper";
import { encryptWithAES, decryptWithAES } from "../../helpers/commonHelpers";
import SmallLoaderButton from "../Common/SmallLoaderButton";
import AgendaAccordianHeader from "../Common/AgendaAccordianHeader";
import NotifyActionAccordianHeader from "../Common/NotifyActionAccordianHeader";
import AddAgendaAccordianHeader from "../Common/AddAgendaAccordianHeader";

const AddAgendaModal = (props) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
  };

  const formats = ["header", "bold", "italic", "underline", "list", "bullet"];
  const regularExpressionForAgendaTitle =
    /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}\[\]]+$/;
  const dispatch = useDispatch();
  const accessToken = localStorage.getItem("accessToken");

  const [errors, setErrors] = useState({});
  const [agendaDatas, setAgendaDatas] = useState([]);
  const [selectedAgendaId, setSelectedAgendaId] = useState(null);

  const [agendaNumber, setAgendaNumber] = useState(0);
  const [addLoading, setAddLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [agendaDatas2, setAgendaDatas2] = useState([]);
  const [selectedAgenda, setSelectedAgenda] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    timeLine: 1,
  });
  const [topic, setTopic] = useState("");
  const minuteDatas = useSelector((state) => state.minute);
  const meetingDatas = useSelector((state) => state.meeting);
  const [isDeleteAgendaModal, setIsDeleteAgendaModal] = useState(false);
  const [remainingTimeLine, setRemainingTimeLine] = useState(0);
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const [maxAllowedMinutes, setMaxAllowedMinutes] = useState(0);
  const [usedLocalMinutes, setUsedLocalMinutes] = useState(0);
  function getRemainingMinutes(fromTimeStr, toTimeStr, actualDate) {
    const date = actualDate?.slice(0, 10); // format YYYY-MM-DD
    const fromTime = new Date(`${date}T${fromTimeStr}:00`);
    const toTime = new Date(`${date}T${toTimeStr}:00`);
    const diffInMilliseconds = toTime - fromTime;
    return Math.max(0, Math.floor(diffInMilliseconds / 60000)); // Ensure non-negative
  }

  useEffect(() => {
    const meeting = meetingDatas?.singleMeetingDetails;

    const totalMinutes = getRemainingMinutes(
      meeting?.actualFromTime,
      meeting?.actualToTime,
      meeting?.actualDate
    );
    const usedMinutes =
      meeting?.agendasDetail?.reduce(
        (sum, agenda) => sum + parseInt(agenda?.timeLine || 0),
        0
      ) || 0;

    const remaining = totalMinutes - usedMinutes;
    setRemainingMinutes(Math.max(0, remaining - usedLocalMinutes));

    if (props?.fromMinute) {
      setFormData({
        title: "",
        timeLine: 1,
      });
    }
    if (remaining - usedLocalMinutes === 0) {
      setFormData({ title: "", timeLine: 0 });
    }
  }, [meetingDatas, agendaDatas]);
  let totalMinutes = 0;
  let remaining = 0;
  const timlineFunction = () => {
    dispatch(
      getSingleMeetingDetailsForUpdate(
        meetingDatas?.singleMeetingDetails?._id,
        accessToken
      )
    );
    totalMinutes = getRemainingMinutes(
      meetingDatas.singleMeetingDetails?.actualFromTime,
      meetingDatas.singleMeetingDetails?.actualToTime,
      meetingDatas.singleMeetingDetails?.actualDate
    );

    const usedMinutes =
      meetingDatas.singleMeetingDetails?.agendasDetail?.reduce(
        (sum, agenda) => sum + parseInt(agenda?.timeLine || 0),
        0
      ) || 0;
    const ref = usedMinutes + parseInt(formData.timeLine);
    remaining = totalMinutes - parseInt(ref);
    setRemainingMinutes(Math.max(0, remaining));
  };

  const handleSubmit = () => {
    const newErrors = validateForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const checkDuplicateTitleFromProps = props.agendaDetails?.find(
        (agenda) => agenda?.title.trim() === formData?.title.trim()
      );
      if (checkDuplicateTitleFromProps) {
        toast.error("Duplicate title found.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }

      props.addAgenda({
        ...formData,
        topic,
      });

      setTopic(null);

      if (formData?.timeLine === "") {
        setUsedLocalMinutes(0);

        setFormData({
          title: " ",
          timeLine: remaining - 0 === 0 ? 0 : 1,
        });
        if (remaining - 0 === 0) {
          setFormData({ title: "", timeLine: 0 });
        }
      } else {
        setUsedLocalMinutes(parseInt(formData?.timeLine));
        setFormData({
          title: " ",
          timeLine: remaining - formData?.timeLine === 0 ? 0 : 1,
        });
        if (remaining - formData?.timeLine === 0) {
          setFormData({ title: "", timeLine: 0 });
        }
      }
    }
  };
  const setDeleteAgendaModalStatus = (status, agenda) => {
    dispatch(setSuccess(false));
    setAgendaDatas2(agenda);
    setIsDeleteAgendaModal(status);
  };

  const handleSubmit2 = () => {
    const newErrors = validateForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const checkDuplicateTitle = agendaDatas?.find(
        (agenda) => agenda?.title.trim() === formData?.title.trim()
      );
      if (checkDuplicateTitle) {
        toast.error("Duplicate title found.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }

      const checkDuplicateTitleFromProps = props.agendaDetails?.find(
        (agenda) => agenda?.title.trim() === formData?.title.trim()
      );
      if (checkDuplicateTitleFromProps) {
        toast.error("Duplicate title found.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }

      if (meetingDatas?.singleMeetingDetails?.organizationId !== undefined) {
        // const encryptedTopic = encryptWithAES(topic)
        // setTopic(encryptedTopic)
        const payload = {
          agendaData: [
            {
              topic: encryptWithAES(topic),
              title: cleanInput(formData.title),
              timeLine: formData.timeLine === "" ? 0 : formData.timeLine,
              meetingId: meetingDatas?.singleMeetingDetails?._id,
              organizationId:
                meetingDatas?.singleMeetingDetails?.organizationId,
            },
          ],
        };

        setAddLoading(true);
        const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/agenda/createAgendaWithMinutes`;
        const headerObject = {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
          },
        };

        axios
          .post(webApiUrl, payload, headerObject)
          .then((res) => {
            const resData = res.data;

            if (resData.data?.isInValidUser) {
              dispatch(setInValidUser(true));
              toast.error(resData.message, {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }

            if (resData.success) {
              props.addAgenda(resData?.data);
              setTopic(null);
              setFormData({
                title: " ",
                timeLine: 1,
              });

              toast.success(resData.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
              setAgendaDatas([...agendaDatas, resData?.data]);

              timlineFunction();
              if (remainingMinutes === 0) {
                setFormData({ title: "", timeLine: 0 });
              }
            } else {
              toast.error(resData.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
            setAddLoading(false);
          })
          .catch((err) => {
            setAddLoading(false);
            toast.error(constantMessages.serverErrorMessage + " Add Agenda", {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          });
      }
    }
  };

  const handleSubmit3 = () => {
    const newErrors = validateForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const checkDuplicateTitleFromProps = props.agendaDetails?.find(
        (agenda) => agenda?.title.trim() === formData?.title.trim()
      );
      if (checkDuplicateTitleFromProps) {
        toast.error("Duplicate title found.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }
      const checkDuplicateTitle = agendaDatas?.find(
        (agenda) => agenda?.title.trim() === formData?.title.trim()
      );
      if (checkDuplicateTitle) {
        toast.error("Duplicate title found.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        return;
      }

      setTopic(null);
      setFormData({
        title: " ",
        timeLine: 1,
      });

      const payload = {
        agendaData: [
          {
            topic: encryptWithAES(topic),
            title: cleanInput(formData.title),
            timeLine: formData.timeLine === "" ? 0 : formData?.timeLine,
            meetingId: meetingDatas?.singleMeetingDetails?._id,
            organizationId: meetingDatas?.singleMeetingDetails?.organizationId,
          },
        ],
      };
      const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/agenda/createAgendaWithMinutes`;
      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      };

      setAddLoading(true);
      axios
        .post(webApiUrl, payload, headerObject)
        .then((res) => {
          const resData = res.data;

          if (resData.data?.isInValidUser) {
            dispatch(setInValidUser(true));
            toast.error(resData.message, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
          if (resData.success) {
            toast.success(resData.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            dispatch(
              getSingleMeetingDetailsForUpdate(
                meetingDatas?.singleMeetingDetails?._id,
                accessToken
              )
            );
            const totalMinutes = getRemainingMinutes(
              meetingDatas.singleMeetingDetails?.actualFromTime,
              meetingDatas.singleMeetingDetails?.actualToTime,
              meetingDatas.singleMeetingDetails?.actualDate
            );

            const usedMinutes =
              meetingDatas.singleMeetingDetails?.agendasDetail?.reduce(
                (sum, agenda) => sum + parseInt(agenda?.timeLine || 0),
                0
              ) || 0;
            const ref = usedMinutes + parseInt(formData.timeLine);

            const remaining = totalMinutes - parseInt(ref);

            setRemainingMinutes(Math.max(0, remaining)); // Avoid negative remainin
            setAgendaDatas([...agendaDatas, resData?.data]);
            if (remainingMinutes === 0) {
              setFormData({ title: "", timeLine: 0 });
              setErrors({});
            }
          } else {
            toast.error(resData.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }

          setAddLoading(false);
        })
        .catch((err) => {
          toast.error(constantMessages.serverErrorMessage + " Add Agenda", {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  };

  const deleteAgenda = (agendaId) => {
    const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/agenda/deleteAgenda/${agendaId}`;
    const headerObject = {
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };
    const payload = {
      meetingId: meetingDatas?.singleMeetingDetails?._id,
    };

    setDeleteLoading(true);
    axios
      .put(webApiUrl, payload, headerObject)
      .then((res) => {
        const resData = res.data;

        if (resData.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        if (resData.success) {
          toast.success(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          const modiFiedData = agendaDatas.filter(
            (agenda) => agenda?._id !== agendaId
          );

          setAgendaDatas(modiFiedData);
          if (typeof props?.deleteAgenda === "function") {
            props.deleteAgenda(agendaId);
          }
          dispatch(
            getSingleMeetingDetailsForUpdate(
              meetingDatas?.singleMeetingDetails?._id,
              accessToken
            )
          );
          setTopic(null);
          if (remainingMinutes === 0) {
            setFormData({ title: "", timeLine: 0 });
          } else {
            setFormData({ title: "", timeLine: 1 });
          }
        } else {
          toast.error(resData.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
        setDeleteLoading(false);
        setIsDeleteAgendaModal(false);
      })
      .catch((err) => {
        console.log(err);
        setDeleteLoading(false);
        if (handleApiError(err)) return;
      });
  };

  const validateAgendaTitle = () => {
    const errors = {};
    if (!formData?.title.trim()) {
      errors.title = constantMessages.titleRequired;
    } else if (
      formData.title.trim().length < 5 ||
      formData.title.trim().length > 100
    ) {
      errors.title = constantMessages.stringLengthError;
    } else if (
      !regularExpressionForAgendaTitle.test(cleanInput(formData.title))
    ) {
      errors.title = constantMessages.titleRegexError;
    }

    setErrors(errors);
    // setSuggestions([])
  };
  const validateAgendaTime = () => {
    const errors = {};
    if (remainingMinutes === 0) {
      setErrors({});
      return;
    }

    if (formData.timeLine > remainingMinutes || formData.timeLine < 1) {
      errors.timeLine = constantMessages.invalidTime;
    }

    setErrors(errors);
  };

  const handleChange = (e, uid) => {
    setErrors({});

    const { name, value } = e.target;

    setFormData({
      ...formData,

      [name]: value,
    });
  };

  const validateForm = () => {
    const errors = {};

    if (!formData?.title.trim()) {
      errors.title = constantMessages.titleRequired;
    } else if (
      formData.title.trim().length < 5 ||
      formData.title.trim().length > 100
    ) {
      errors.title = constantMessages.stringLengthError;
    } else if (
      !regularExpressionForAgendaTitle.test(cleanInput(formData.title))
    ) {
      errors.title = constantMessages.titleRegexError;
    }

    return errors;
  };

  const validateAgendaTopic = () => {
    const errors = {};

    setErrors(errors);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
    // Block the 'e', 'E', '+', and '-' keys
    if (["e", "E", "+", "-"].includes(event.key)) {
      event.preventDefault();
    }
  };
  const handleValue = (value) => {
    setTopic(value);
  };

  const closeModal = () => {
    if (props?.fromMinute) {
    } else {
      if (agendaDatas?.length !== 0) {
        dispatch(
          getSingleMeetingDetailsForUpdate(
            meetingDatas?.singleMeetingDetails?._id,
            accessToken
          )
        );
      }
    }
    setErrors({});
    setTopic(null);
    setFormData({
      title: "",
      timeLine: 1,
    });
    props.setIsAddAgendaModal(false);
    setAgendaDatas([]);
  };

  const resetModalMinute = (agenda) => {
    if (selectedAgendaId) {
      setTopic(null);
      setFormData({
        ...formData,
        title: "",
        timeLine: 1,
      });
      setSelectedAgendaId(null);
      setErrors({});
    } else {
      setTopic(null);
      setFormData({
        title: "",
        timeLine: 1,
      });
      setErrors({});
      setAgendaNumber(0);
    }
  };
  const resetModal = (agenda) => {
    if (selectedAgendaId) {
      setTopic(null);
      setFormData({
        ...formData,
        title: "",
        timeLine: 1,
      });
      setSelectedAgendaId(null);
      setErrors({});
      const meeting = meetingDatas?.singleMeetingDetails;

      if (
        !meeting?.actualFromTime ||
        !meeting?.actualToTime ||
        !meeting?.actualDate
      ) {
        return;
      }

      const totalMinutes = getRemainingMinutes(
        meeting.actualFromTime,
        meeting.actualToTime,
        meeting.actualDate
      );

      // If editing, exclude current agenda's original time
      let usedMinutes = 0;

      usedMinutes = meeting?.agendasDetail?.reduce(
        (sum, agenda) => sum + parseInt(agenda?.timeLine || 0),
        0
      );

      const remaining = totalMinutes - usedMinutes;

      setMaxAllowedMinutes(remaining);
      setRemainingMinutes(Math.max(0, remaining));
    } else {
      setTopic(null);
      setFormData({
        title: "",
        timeLine: 1,
      });
      setErrors({});
      setAgendaNumber(0);
      const meeting = meetingDatas?.singleMeetingDetails;

      if (
        !meeting?.actualFromTime ||
        !meeting?.actualToTime ||
        !meeting?.actualDate
      ) {
        return;
      }

      const totalMinutes = getRemainingMinutes(
        meeting.actualFromTime,
        meeting.actualToTime,
        meeting.actualDate
      );

      // If editing, exclude current agenda's original time
      let usedMinutes = 0;

      usedMinutes = meeting?.agendasDetail?.reduce(
        (sum, agenda) => sum + parseInt(agenda?.timeLine || 0),
        0
      );

      const remaining = totalMinutes - usedMinutes;

      setMaxAllowedMinutes(remaining);
      setRemainingMinutes(Math.max(0, remaining));
    }
  };
  const popoverHoverFocus = (title) => {
    return (
      <Popover id="popover-basic" className="custom-popover">
        <Popover.Body className="popover-body">{title}</Popover.Body>
      </Popover>
    );
  };

  const setEdit = (agenda) => {
    setTimeout(() => {
      const topSection = document.getElementById("scroll-top-agenda");
      if (topSection) {
        topSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);

    window.scrollTo({ top: 0, behavior: "smooth" });
    setFormData({
      title: agenda?.title,
      timeLine: agenda?.timeLine,
    });
    // alert("CALLED SET EDIT 1")
    setTopic(decryptWithAES(agenda?.topic));
    setSelectedAgendaId(agenda?._id);
    setSelectedAgenda(agenda);

    const meeting = meetingDatas?.singleMeetingDetails;

    if (
      !meeting?.actualFromTime ||
      !meeting?.actualToTime ||
      !meeting?.actualDate
    ) {
      return;
    }

    const totalMinutes = getRemainingMinutes(
      meeting.actualFromTime,
      meeting.actualToTime,
      meeting.actualDate
    );
    let usedMinutes = 0;
    usedMinutes =
      meeting?.agendasDetail?.reduce(
        (sum, agenda) => sum + parseInt(agenda?.timeLine || 0),
        0
      ) || 0;

    const editingAgendaId = agendaDatas?.[0]?._id; // Adjust based on selected agenda

    const remaining = parseInt(totalMinutes) - parseInt(usedMinutes);
    const drf = parseInt(remaining) + parseInt(agenda.timeLine);

    setMaxAllowedMinutes(drf);

    setRemainingMinutes(Math.max(0, drf));
  };

  const handleEditSubmit = async () => {
    const checkDuplicateTitle = agendaDatas?.find(
      (agenda) => agenda?.title.trim() === formData?.title.trim()
    );

    if (checkDuplicateTitle && selectedAgendaId !== checkDuplicateTitle?._id) {
      toast.error("Duplicate title found.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }

    setShowEdit(true);
    const newErrors = validateForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const timeLineData = formData?.timeLine === "" ? 0 : formData?.timeLine;
      const payload = {
        title: cleanInput(formData?.title),
        timeLine: timeLineData,
        topic: encryptWithAES(topic),
        organizationId: meetingDatas?.singleMeetingDetails?.organizationId,
        meetingId: meetingDatas?.singleMeetingDetails?._id,
      };

      const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/agenda/updateAgenda/${selectedAgendaId}`;
      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      };
      setEditLoading(true);
      axios
        .put(webApiUrl, payload, headerObject)
        .then(async (res) => {
          const resData = res.data;

          if (resData.data?.isInValidUser) {
            dispatch(setInValidUser(true));
            toast.error(resData.message, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
          if (resData.success) {
            toast.success(resData.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });

            const modifiedAgenda = await agendaDatas.map((agenda) => {
              if (agenda?._id === selectedAgendaId) {
                agenda.title = payload.title;
                agenda.timeLine = payload?.timeLine;
                agenda.topic = topic;
              }
              return agenda;
            });

            setAgendaDatas(modifiedAgenda);

            setTopic(null);
            setFormData({
              title: "",
              timeLine: 1,
            });
            setErrors({});
            setSelectedAgendaId(null);
            setSelectedAgenda(null);
            setAgendaNumber(0);

            dispatch(
              getSingleMeetingDetailsForUpdate(
                meetingDatas?.singleMeetingDetails?._id,
                accessToken
              )
            );
            const totalMinutes = getRemainingMinutes(
              meetingDatas.singleMeetingDetails?.actualFromTime,
              meetingDatas.singleMeetingDetails?.actualToTime,
              meetingDatas.singleMeetingDetails?.actualDate
            );
            const usedMinutes =
              meetingDatas.singleMeetingDetails?.agendasDetail?.reduce(
                (sum, agenda) => sum + parseInt(agenda?.timeLine || 0),
                0
              ) || 0;
            const remaining = totalMinutes;
            setRemainingMinutes(Math.max(0, remaining));
          } else {
            toast.error(resData.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
          setEditLoading(false);
        })
        .catch((err) => {
          setEditLoading(false);

          toast.error(constantMessages.serverErrorMessage + " Add Agenda", {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  };
  // const [sentence, setSentence] = useState("");
  const [lastWord, setLastWord] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  // Get last word when sentence changes
  useEffect(() => {
    const words = formData?.title?.split(" ");
    const currentWord = words[words.length - 1];
    setLastWord(currentWord);

    // Fetch suggestions if word is not empty
    if (currentWord && currentWord.length > 2) {
      const timeout = setTimeout(async () => {
        const response = await fetch(
          `https://api.datamuse.com/sug?s=${currentWord}`
        );
        const data = await response.json();
        setSuggestions(data.map((item) => item.word));
      }, 300); // debounce
      return () => clearTimeout(timeout);
    } else {
      setSuggestions([]);
    }
  }, [formData?.title]);
  const handleSuggestionForTitleClick = (suggestedWord) => {
    //  alert(1)
    const words = formData?.title?.trim().split(" ");
    words[words.length - 1] = suggestedWord;
    const newSentence = words.join(" ") + " ";
    //setSentence(newSentence);
    setFormData({
      ...formData,
      title: newSentence,
    });
    setSuggestions([]);
  };

  return (
    <>
      <Modal
        size="lg"
        show={props.IsAddAgendaModal}
        onHide={() => closeModal()}
        backdrop="static"
        onClick={() => {
          setSuggestions([]);
        }}
      >
        <Modal.Dialog className="create-add-agenda">
          <div className="modal-header attendees-modal">
            <div>
              {selectedAgendaId === null ? (
                <h4 className="modal-title">
                  Add Agenda {props?.totalAgenda + 1}
                </h4>
              ) : (
                <h4 className="modal-title">Edit Agenda{agendaNumber}</h4>
              )}
            </div>
            <div>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => closeModal()}
              ></button>
            </div>
          </div>

          <Modal.Body
            className="attendees-popup modal-margin"
            id="scroll-top-agenda"
          >
            <div className="open-div">
              <div className="minutes-box no-border">
                <div className="form-group">
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-12">
                        <label className="mb-1">
                          Agenda Title <span className="star-mark">*</span>
                        </label>
                      </div>
                      <div className="col-md-12">
                        <input
                          type="text"
                          placeholder="Enter title"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                          onBlur={validateAgendaTitle}
                          autoComplete="off"

                          //  onChange={(e) => setQuery(e.target.value)}
                        />
                        {suggestions.length > 0 && (
                          <ul
                            style={{
                              position: "absolute",
                              top: "60px",
                              left: 0,
                              backgroundColor: "#fff",
                              border: "1px solid #ccc",
                              width: "100%",
                              zIndex: 10,
                              listStyle: "none",
                              padding: "0",
                              margin: "4px 0",
                              maxHeight: "150px",
                              overflowY: "auto",
                            }}
                          >
                            {suggestions.map((word, index) => (
                              <li
                                key={index}
                                onClick={() => {
                                  handleSuggestionForTitleClick(word);
                                }}
                                style={{
                                  padding: "10px",
                                  cursor: "pointer",
                                  borderBottom: "1px solid #eee",
                                }}
                              >
                                {word}
                              </li>
                            ))}
                          </ul>
                        )}
                        {errors.title ? (
                          <span className="error-message">{errors.title}</span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="mb-1">
                        What are the topic to discuss ?
                      </label>
                    </div>
                    <div className="col-md-12">
                      <ReactQuill
                        theme="snow"
                        placeholder="Please add topic"
                        onChange={handleValue}
                        value={topic}
                        onBlur={validateAgendaTopic}
                        modules={modules}
                        formats={formats}
                        className="custom-quill-editor"
                        style={{ background: "white" }}
                      />

                      <p className="success-message">
                        {getStringLengthAfterHTMLParse(topic)} Characters
                      </p>
                      {errors.topic && (
                        <span className="error-message">{errors.topic}</span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="form-group m-0">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="mb-1">
                        How long will this agenda item take to discuss?
                      </label>
                    </div>

                    <div className="col-md-12">
                      <div className="time-taken bg-white">
                        <input
                          name="timeLine"
                          value={formData.timeLine}
                          onChange={(e) => {
                            const input = e.target.value;
                            const isValidNumber = /^[1-9][0-9]*$/.test(input);
                            const value = parseInt(input);
                            if (
                              input === "" ||
                              (isValidNumber && value <= remainingMinutes)
                            ) {
                              handleChange(e);
                            }
                          }}
                          onBlur={validateAgendaTime}
                          required
                          onKeyDown={handleKeyDown}
                          type="number"
                          autoComplete="off"
                          max={remainingMinutes}
                        />

                        <div className="minute_box">mins</div>
                      </div>

                      {/* Error message if any */}
                      {errors.timeLine && (
                        <span className="error-message">{errors.timeLine}</span>
                      )}

                      <div
                        className="min-left-text"
                        style={{
                          marginTop: "5px",
                          color:
                            formData.timeLine > remainingMinutes ||
                            remainingMinutes - formData.timeLine === 0
                              ? "red"
                              : "#008000",
                        }}
                      >
                        {formData.timeLine > remainingMinutes
                          ? `${remainingMinutes} minute(s)`
                          : `${
                              remainingMinutes - formData.timeLine
                            } minute(s) left`}
                      </div>
                    </div>

                    {/* Alert when remainingMinutes is 0 */}
                    {remainingMinutes - formData.timeLine === 0 && (
                      <div className="col-12 mt-2">
                        <div className="alert alert-warning padding-8">
                          <strong>Note:</strong> Please increase Meeting
                          Duration (e.g., by 1 or 2 hours) to add more agenda
                          items otherwise.
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="mt-3 plus pointer"></div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <div className="md-footer">
            <Modal.Footer>
              {props?.fromMinute ? (
                <Button
                  variant=""
                  onClick={() => resetModalMinute()}
                  type="button"
                  className="add-minutes Mom-btn"
                >
                  <p>Reset</p>
                </Button>
              ) : (
                <Button
                  variant=""
                  onClick={() => resetModal()}
                  type="button"
                  className="add-minutes Mom-btn"
                >
                  <p>Reset</p>
                </Button>
              )}

              {props?.fromMinute && selectedAgendaId === null ? (
                <>
                  {!minuteDatas.loading ? (
                    <Button
                      className="create-meeting-button Mom-btn"
                      variant=""
                      onClick={handleSubmit}
                    >
                      <p>Submit</p>
                    </Button>
                  ) : (
                    <div
                      className="meeting-page"
                      style={{ textAlign: "center" }}
                    >
                      <SmallLoaderButton />
                    </div>
                  )}
                </>
              ) : props?.fromEditMeeting && selectedAgendaId === null ? (
                <>
                  {!addLoading ? (
                    <Button
                      className="create-meeting-button Mom-btn"
                      variant=""
                      onClick={handleSubmit2}
                    >
                      <p>Submit</p>
                    </Button>
                  ) : (
                    <div
                      className="meeting-page"
                      style={{ textAlign: "center" }}
                    >
                      <SmallLoaderButton />
                    </div>
                  )}
                </>
              ) : props?.fromViewMeeting && selectedAgendaId === null ? (
                <>
                  {!addLoading ? (
                    <Button
                      className="create-meeting-button Mom-btn"
                      variant=""
                      onClick={handleSubmit3}
                    >
                      <p>Submit</p>
                    </Button>
                  ) : (
                    <div
                      className="meeting-page"
                      style={{ textAlign: "center" }}
                    >
                      <SmallLoaderButton />
                    </div>
                  )}
                </>
              ) : selectedAgendaId !== null ? (
                <>
                  {!editLoading && selectedAgendaId !== null ? (
                    <Button
                      className="create-meeting-button Mom-btn"
                      variant=""
                      onClick={handleEditSubmit}
                    >
                      <p>Update</p>
                    </Button>
                  ) : (
                    <div
                      className="meeting-page"
                      style={{ textAlign: "center" }}
                    >
                      <SmallLoaderButton />
                    </div>
                  )}
                </>
              ) : null}
            </Modal.Footer>
          </div>
        </Modal.Dialog>

        {agendaDatas?.length !== 0 ? (
          <div className="form-group agenda ag-data">
            <label className="mb-2">
              <h4 className="mb-0">Agenda(s)</h4>
            </label>
            {agendaDatas?.length !== 0 &&
              agendaDatas?.map((agenda, index) => {
                return (
                  <div className="agenda-box-border after-add-agenda-bg">
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item
                        eventKey={index.toString()}
                        key={index}
                        className="agenda-accordion"
                      >
                        <AddAgendaAccordianHeader
                          agenda={agenda}
                          index={index}
                        />
                        <Accordion.Body>
                          <div className="accordion-bbb d-flex justify-content-between">
                            <div className="edit-meeting-left-accordions">
                              <div className="form-group">
                                <div className="row">
                                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                    <label className="mt-1 mb-1">
                                      Agenda Title
                                    </label>
                                  </div>
                                  <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                    <p> {agenda.title}</p>
                                  </div>
                                </div>
                              </div>
                              {checkEmptyString(agenda?.topic) === null ||
                              checkEmptyString(agenda?.topic) === " " ||
                              checkEmptyString(agenda?.topic) === undefined ||
                              agenda?.topic === null ? null : (
                                <div className="form-group">
                                  <div className="row">
                                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                      <label className="mt-1 mb-1">
                                        Topic to Discuss
                                      </label>
                                    </div>
                                    <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                      <div className="mb-2 text-editor">
                                        {agenda?.topic
                                          ? parse(decryptWithAES(agenda.topic))
                                          : null}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div className=" form-group">
                                <div className="row">
                                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                                    <label className="mt-1 mb-1">
                                      Timeline
                                    </label>
                                  </div>
                                  <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                    <p> {agenda.timeLine} Mins</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="accordianagenda-edit-delete">
                              <div className="btn-outerbox">
                                <div className="d-inline-block menu-dropdown custom-dropdown">
                                  <Dropdown className="fff">
                                    <Dropdown.Toggle>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="#000"
                                        className="bi bi-three-dots-vertical"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                      </svg>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        href="#"
                                        onClick={() => {
                                          setEdit(agenda);
                                          setAgendaNumber(
                                            props?.totalAgenda -
                                              (agendaDatas?.length - index) +
                                              1
                                          );
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          fill="currentColor"
                                          className="bi bi-pencil-square me-1"
                                          viewBox="0 0 19 16"
                                        >
                                          <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                          <path
                                            fill-rule="evenodd"
                                            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                          />
                                        </svg>
                                        Edit
                                      </Dropdown.Item>
                                      <hr
                                        className="dropdown-divider"
                                        role="separator"
                                      />
                                      <Dropdown.Item
                                        className="delete-drp"
                                        href="#"
                                        onClick={() =>
                                          setDeleteAgendaModalStatus(
                                            true,
                                            agenda
                                          )
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="18"
                                          height="18"
                                          fill="currentColor"
                                          className="me-2 bi bi-trash3"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                        </svg>
                                        Delete
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                );
              })}
          </div>
        ) : null}
      </Modal>

      <Modal
        show={isDeleteAgendaModal}
        onClick={(e) => setIsDeleteAgendaModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Agenda</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete {agendaDatas2?.title} ?</Modal.Body>
        <Modal.Footer>
          <Button
            variant=""
            onClick={(e) => setIsDeleteAgendaModal(false)}
            className="add-btn Mom-btn"
          >
            <p>No</p>
          </Button>

          {!deleteLoading ? (
            <Button
              type="button"
              variant=""
              className="create-meeting-button Mom-btn"
              onClick={(e) => {
                deleteAgenda(agendaDatas2?._id, agendaDatas2.timeLine);
              }}
            >
              <p>Yes</p>
            </Button>
          ) : (
            <div className="meeting-page" style={{ textAlign: "center" }}>
              <SmallLoaderButton />
            </div>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddAgendaModal;
